module.exports = __webpack_public_path__ + "media/img/pages/companies/fachhochschule-nordwestschweiz-83f9cee4ab00d611d383f39086d5b754.jpg";